__webpack_require__.p = "/portfolio/blog-app/";